import { createContext, useContext } from 'react'
import PrintQueueEntry from '../../../../../types/api/print-queue-entry'
import { DurstPrintDayGroup } from '../../helpers/build-durst-print-day-groups'

export interface DurstQueueContextValue {
    machineDocId: string
    dayGroups: DurstPrintDayGroup[]
    machineEntries: PrintQueueEntry[]
}

export const DurstQueueContext = createContext<DurstQueueContextValue | null>(null)

export function useDurstQueueContext() {
    return useContext(DurstQueueContext)
}
